// extracted by mini-css-extract-plugin
export default {"clipCreate":"j2x89"};